import { PlayableGameState } from "./PlayableGameState.js";
import type { DescribePlayerNames } from "./GameState.js";
import { getDescribePlayerName } from "./GameState.js";
import { isSameRuntimeType } from "../../../util/tsutils.js";


/**
 * A game state where the game is waiting for a player to roll the dice.
 */
export class WaitingForRollGameState extends PlayableGameState {
    override describe(playerNames?: DescribePlayerNames): string {
        const playerName = getDescribePlayerName(this.getTurn(), playerNames);
        return `Waiting for ${playerName} to roll the dice`;
    }

    override equals(other: unknown): boolean {
        if (other === this)
            return true;
        if (!isSameRuntimeType(this, other))
            return false;

        return PlayableGameState._baselineEquals(this, other);
    }
}
